export default {
    title: 'Settings',
    profile: 'My Profile',
    name: 'Name',
    company: 'Company',
    email: 'Email',
    language: 'Language',
    logout: 'Log out',
    sessionWarning: {
        title: 'Session Expiring Soon',
        message: 'Your session will expire in {minutes} minutes and {seconds} seconds due to inactivity. Please save your work and continue to stay logged in.',
        timeFormat: '{minutes} minutes and {seconds} seconds remaining',
        secondsFormat: '{seconds} seconds remaining',
        continue: 'Continue Working',
        extending: 'Extending...',
        logout: 'Logout Now'
    },
    inactivity: {
        title: 'Welcome back!',
        message: 'You have been inactive for a while. You can log out and continue later or continue now.',
        logout: 'Log out',
        continue: 'Continue now'
    }
};
